import { GET_DASHBOARD_DATA, GET_DASHBOARD_ATTENDANCE_SUMMARY, GET_DASHBOARD_CALENDAR_DATA_ALL } from '../../actions/actionTypes';
import update from 'immutability-helper';

const dashboardReducer = (state = [], action) => {
    switch (action.type) {

        case GET_DASHBOARD_DATA:
            if (action.payload && action.payload.data) {
                return update(state, {
                    calendar: {
                        $set: (
                            action.payload.data.CalendarList ? action.payload.data.CalendarList : []
                        )
                    },
                    incompleteAttendance: {
                        $set: (
                            action.payload.data.IncomplteAttendanceList ? action.payload.data.IncomplteAttendanceList : []
                        )
                    },
                    employeeAttendanceSummary: {
                        $set: (
                            action.payload.data.EmployeeAttendanceSummary ? action.payload.data.EmployeeAttendanceSummary : []
                        )
                    },
                    userRole: {
                        $set: (
                            action.payload.data.UserRole ? action.payload.data.UserRole : []
                        )
                    },
                    employeeId: {
                        $set: (
                            action.payload.data.EmployeeId ? action.payload.data.EmployeeId : []
                        )
                    },

                    isLoading: { $set: false },
                });
            } else {
               
                return update(state, {
                    isLoading: { $set: false },
                });
            }

        case GET_DASHBOARD_ATTENDANCE_SUMMARY:
            if (action.payload && action.payload.data) {
                return update(state, {                    
                    employeeAttendanceSummary: {
                        $set: (
                            action.payload.data ? action.payload.data : []
                        )
                    },
                    isLoading: { $set: false },
                });
            }else {
                return update(state, {
                    isLoading: { $set: false },
                });
            }
            case GET_DASHBOARD_CALENDAR_DATA_ALL:
                if (action.payload && action.payload.data) {
                    return update(state, {                    
                        calendar: {
                            $set: (
                                action.payload.data ? action.payload.data : []
                            )
                        },
                        isLoading: { $set: false },
                    });
                }else {
                    return update(state, {
                        isLoading: { $set: false },
                    });
                }
            
        default:
            return state;
    }
}

export default dashboardReducer;
